import {
  type DesignBody,
  FACE_KEYS,
  type FaceKey,
  type ResolvedEditAreaDefinition,
} from '@repo/api-contracts';

/** design: 합성해 보여 준다. empty: 인쇄 영역이 없다(사진만). */
export type ViewableFaceKind = 'design' | 'empty';

export interface ViewableFace {
  readonly face: FaceKey;
  /** 이 면 배치의 컴포넌트에 레이어가 있는지 — 면 탭 점 표시와 첫 면 고르기에 쓴다. */
  readonly hasLayers: boolean;
  readonly kind: ViewableFaceKind;
}

/**
 * 뷰어가 보여 줄 면 목록(V11) — 편집영역에 정의된 면만 FACE_KEYS 순서로.
 * 배치가 없으면 empty, 나머지는 design(격자 표면 위 배치도 휘어 그린다).
 * hasLayers 는 편집기 면 탭과 같은 규칙이다.
 */
export const viewableFaces = (
  definition: ResolvedEditAreaDefinition,
  body: DesignBody,
): readonly ViewableFace[] =>
  FACE_KEYS.flatMap((face): ViewableFace[] => {
    const entry = definition.faces[face];
    if (entry === undefined) return [];
    const hasLayers = entry.placements.some((placement) =>
      body.components.some(
        (component) =>
          component.componentId === placement.componentId && component.layers.length > 0,
      ),
    );
    const kind: ViewableFaceKind = entry.placements.length === 0 ? 'empty' : 'design';
    return [{ face, hasLayers, kind }];
  });
